import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * সমস্যা: আগে কোনো পেজে footer পর্যন্ত scroll করা অবস্থায় nav-এর কোনো
 * লিংকে ক্লিক করলে React Router শুধু পেজের content বদলে দিত, কিন্তু
 * scroll position আগেরটাই থেকে যেত — ফলে নতুন পেজটাও নিচের (footer-এর
 * কাছাকাছি) অংশ থেকে শুরু হতো বলে মনে হতো, উপর থেকে না।
 *
 * এই কম্পোনেন্ট প্রতিবার route (pathname) বদলালে window scroll কে
 * উপরে (top) নিয়ে যায় — যেভাবে সাধারণত সব multi-page ওয়েবসাইট আচরণ করে।
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
